import React from 'react';
import cx from 'classnames';
import {Flex, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from '../../styles/ToDoListConent.module.scss';
import texts from '../../texts';
import {TODOLIST, REMARKS_SUBFORM_NAME, INT_DLG_SUBFORM_NAME, monitor} from '../../consts';
import {startEntity} from '../../../../_shared/GWTBridge/invoke/genPage';
import {isNewApiForm} from '../../../../_shared/GWTBridge/invoke/netForm';
import {Tooltip} from '../../../../components/Common/Tooltip/index';
import {subformZoom} from '../../../../features/Form/actions/screen';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import {sendMonitor} from '../../../../utils/monitoring';

export const ListItemBtns = ({value}: {value: string}) => {
    const openSelected = (subformName: string) => {
        (window as any).hide_home_page?.();
        const isNewApi = isNewApiForm(TODOLIST);
        if (isNewApi) {
            subformZoom(TODOLIST, subformName, value);
        } else {
            startEntity(TODOLIST, TODOLIST, value, subformName);
        }
        const monitorTransactionName =
            subformName === REMARKS_SUBFORM_NAME
                ? monitor.TODOLIST_Text
                : monitor.TODOLIST_InternalDialogue;
        sendMonitor(monitorTransactionName);
    };

    return (
        <div className={styles.listItemBtns}>
            <Flex
                justifyContent="center"
                alignItems="center"
                componentClasses={styles.listItemBtnsWrapper}
            >
                <Tooltip
                    tooltip={texts.remarks_tooltip}
                    position="left center"
                    zIndex={getTopDialogZindex()}
                >
                    <Icon
                        icon={PriorityIcon.zoom}
                        iconColor="primary-700"
                        onClick={() => openSelected(REMARKS_SUBFORM_NAME)}
                        componentClasses={styles.listItemIcon}
                    />
                </Tooltip>
                <Tooltip
                    tooltip={texts.dialog_tooltip}
                    position="left center"
                    zIndex={getTopDialogZindex()}
                >
                    <Icon
                        icon={PriorityIcon.chatbubble}
                        iconColor="primary-700"
                        onClick={() => openSelected(INT_DLG_SUBFORM_NAME)}
                        componentClasses={cx(styles.listItemIcon, styles.chatbubbleMargin)}
                    />
                </Tooltip>
            </Flex>
        </div>
    );
};
